import { render, staticRenderFns } from "./contract-list.vue?vue&type=template&id=d24b133c&scoped=true&"
import script from "./contract-list.vue?vue&type=script&lang=js&"
export * from "./contract-list.vue?vue&type=script&lang=js&"
import style0 from "./contract-list.vue?vue&type=style&index=0&id=d24b133c&prod&lang=scss&scoped=true&"
import style1 from "./contract-list.vue?vue&type=style&index=1&id=d24b133c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24b133c",
  null
  
)

export default component.exports